<template>
    <v-container fluid>
        <!--table head-->
        <v-row 
            class="my-2 subtitle-2 secondary--text pl-12">
            Segments & consumers' material & manufacturing quality preferences
        </v-row>
        <v-divider />
        <v-row class="subtitle-2" no-gutters>
            <v-col cols="2"></v-col>
            <v-divider vertical></v-divider>
                    
            <v-col cols="5" class="tabCell text-center">Consumers' material quality preferences</v-col>
            <v-divider vertical></v-divider>
            <v-col cols="5" class="tabCell text-center">Consumers' manufacturing quality preferences</v-col>
        </v-row>
        <v-row class="subtitle-2 text-center" no-gutters>
            <v-col class="tabCell text-left" cols="2">Segment</v-col>
            <v-divider vertical></v-divider>
             <v-col  v-for="i in 5" :key="`mt-${i}`"
                class="tabCell"
                cols="1">
                Level {{ i }}
            </v-col>
            <v-divider vertical></v-divider>
            <v-col v-for="i in 5" :key="`mn-${i}`"
                class="tabCell"
                cols="1">
                Level {{ i }}
            </v-col>
        </v-row>
        <div v-if="market_segments.length">
            <!--segments tab-->
            <v-row v-for="segment in market_segments" :key="segment.id" no-gutters>
                <v-col cols="2" class="tabCell text-left text-truncate">{{ segment.segment.name }}</v-col>
                <v-col v-for="i in 5" :key="`mt${i}`"
                    class="tabCell text-center">
                    {{ segment[`material_${i}`] }}
                </v-col>
                <v-col v-for="i in 5" :key="`mn${i}`"
                        class="tabCell text-center">
                        {{ segment[`manufacturing_${i}`] }}
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>
//import changeDesign from './modal/changeDesign.vue'
//import deleteSegment from './modal/deleteSegment.vue'

export default {
    name: 'MarketMaterials',
    data() {
        return {
            types: ['Classic', 'Business', 'Casual', 'Innovative', 'Art'],
        }
    },
    computed: {
        market_segments() {
            return this.$store.getters.market_segments;
        }
    },
    methods: {
    },
    components: {
        //changeDesign,
        //deleteSegment
    }
}
</script>